import { Component } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';

@Component({
  selector: 'app-member-activity-component',
  templateUrl: './member-activity.component.html',
})
export class MemberActivityComponent {

  constructor(
    private readonly trelloService: TrelloService, // required
  ) {
  }

}
